import React, { useState, useEffect } from "react";
import "../../../assets/css/student/RoadmapsProgress.css";
import MyStudentLayout from "../../../layouts/Student/MyStudentLayout";

/* ═══════════════════════════════════════════════════════════
   SVG ICONS — all inline, no external library
   Each icon is meaningful and relatable to context
═══════════════════════════════════════════════════════════ */
const Icons = {
  /* View switcher icons */
  GridView: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="3" width="7" height="7" rx="1.5" />
      <rect x="14" y="3" width="7" height="7" rx="1.5" />
      <rect x="3" y="14" width="7" height="7" rx="1.5" />
      <rect x="14" y="14" width="7" height="7" rx="1.5" />
    </svg>
  ),
  TimelineView: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="5" cy="6" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="5" cy="12" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="5" cy="18" r="1.5" fill="currentColor" stroke="none" />
      <line x1="8" y1="6" x2="20" y2="6" />
      <line x1="8" y1="12" x2="20" y2="12" />
      <line x1="8" y1="18" x2="20" y2="18" />
    </svg>
  ),
  FocusView: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="3" width="8" height="18" rx="2" />
      <rect x="13" y="3" width="8" height="11" rx="2" />
      <rect x="13" y="16" width="8" height="5" rx="2" />
    </svg>
  ),

  /* Status icons */
  CheckCircle: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="9" />
      <polyline points="8 12 11 15 16 9" />
    </svg>
  ),
  Lock: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="5" y="11" width="14" height="10" rx="2" />
      <path d="M8 11V7a4 4 0 0 1 8 0v4" />
      <circle cx="12" cy="16" r="1" fill="currentColor" stroke="none" />
    </svg>
  ),
  PlayCircle: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="9" />
      <polygon
        points="10 8 17 12 10 16 10 8"
        fill="currentColor"
        stroke="none"
      />
    </svg>
  ),
  Play: () => (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <polygon points="5 3 19 12 5 21 5 3" />
    </svg>
  ),

  /* KPI icons */
  Roadmap: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 17L9 11L13 15L21 7" />
      <circle cx="3" cy="17" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="9" cy="11" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="13" cy="15" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="21" cy="7" r="1.5" fill="currentColor" stroke="none" />
    </svg>
  ),
  Trophy: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M8 21h8M12 17v4" />
      <path d="M7 4H4.5a2 2 0 0 0 0 4H7" />
      <path d="M17 4h2.5a2 2 0 0 1 0 4H17" />
      <path d="M7 4h10v8a5 5 0 0 1-10 0V4Z" />
    </svg>
  ),
  Lightning: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M13 2L4.5 13.5H11L10.5 22L20 10.5H13.5L13 2Z" />
    </svg>
  ),

  /* Card meta */
  Clock: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="9" />
      <polyline points="12 7 12 12 15.5 14" />
    </svg>
  ),
  Steps: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="4 17 4 13 8 13 8 9 12 9 12 5 20 5" />
      <line x1="4" y1="17" x2="20" y2="17" />
    </svg>
  ),

  /* Action & misc */
  Search: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="11" cy="11" r="7" />
      <line x1="17" y1="17" x2="22" y2="22" />
    </svg>
  ),
  MoreDots: () => (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <circle cx="5" cy="12" r="1.8" />
      <circle cx="12" cy="12" r="1.8" />
      <circle cx="19" cy="12" r="1.8" />
    </svg>
  ),
  ChevronRight: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="9 18 15 12 9 6" />
    </svg>
  ),
  Book: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
      <line x1="8" y1="7" x2="15" y2="7" />
      <line x1="8" y1="11" x2="13" y2="11" />
    </svg>
  ),
  Brain: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588 4 4 0 0 0 7.97 1.997A3.5 3.5 0 0 0 12 19V5Z" />
      <path d="M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588 4 4 0 0 1-7.97 1.997A3.5 3.5 0 0 1 12 19V5Z" />
      <path d="M12 12H8" />
      <path d="M12 12h4" />
    </svg>
  ),
};

/* ═══════════════════════════════════════════════════════════
   DATA
═══════════════════════════════════════════════════════════ */
const ROADMAPS = [
  {
    id: 1,
    title: "Frontend Developer Path",
    level: "beginner",
    duration: "3 months",
    progress: 62,
    skills: ["HTML", "CSS", "JavaScript", "React"],
    accent: "#3B82F6",
    aiTag: "Recommended for you",
    steps: [
      { id: "s1", name: "HTML Fundamentals", status: "completed" },
      { id: "s2", name: "CSS Mastery", status: "completed" },
      { id: "s3", name: "JavaScript Core", status: "in-progress" },
      { id: "s4", name: "React Basics", status: "locked" },
      { id: "s5", name: "State Management", status: "locked" },
    ],
    modules: [
      {
        id: "m1",
        name: "HTML & Accessibility",
        status: "completed",
        desc: "Semantic markup, ARIA roles, and document structure.",
      },
      {
        id: "m2",
        name: "CSS Layout Systems",
        status: "completed",
        desc: "Flexbox, Grid, and responsive design patterns.",
      },
      {
        id: "m3",
        name: "JavaScript ES2024",
        status: "in-progress",
        desc: "Closures, async/await, and modern API patterns.",
      },
      {
        id: "m4",
        name: "React & Hooks",
        status: "locked",
        desc: "Component model, hooks, and performance.",
      },
    ],
    insights: [
      { type: "speed", text: "You are 18% faster than the average learner" },
      {
        type: "warn",
        text: "Weak area detected: JavaScript async programming",
      },
      { type: "next", text: "Recommended next: React Hooks deep-dive" },
    ],
  },
  {
    id: 2,
    title: "Full-Stack Engineering",
    level: "intermediate",
    duration: "5 months",
    progress: 34,
    skills: ["Node.js", "Express", "PostgreSQL", "REST API"],
    accent: "#10B981",
    aiTag: "Based on your Wishlist",
    steps: [
      { id: "s1", name: "Node Fundamentals", status: "completed" },
      { id: "s2", name: "REST API Design", status: "in-progress" },
      { id: "s3", name: "Database Modeling", status: "locked" },
      { id: "s4", name: "Auth & Security", status: "locked" },
      { id: "s5", name: "Deployment", status: "locked" },
    ],
    modules: [
      {
        id: "m1",
        name: "Node.js Core",
        status: "completed",
        desc: "Event loop, streams, and modules.",
      },
      {
        id: "m2",
        name: "API Architecture",
        status: "in-progress",
        desc: "REST conventions, error handling, pagination.",
      },
      {
        id: "m3",
        name: "SQL & ORMs",
        status: "locked",
        desc: "PostgreSQL, Prisma, query optimization.",
      },
      {
        id: "m4",
        name: "Auth Patterns",
        status: "locked",
        desc: "JWT, OAuth 2.0, session management.",
      },
    ],
    insights: [
      { type: "speed", text: "On track — completing 3 modules per week" },
      { type: "warn", text: "Weak area: SQL window functions and indexing" },
      { type: "next", text: "Suggested next roadmap: Cloud Infrastructure" },
    ],
  },
  {
    id: 3,
    title: "Data Science Foundations",
    level: "advanced",
    duration: "4 months",
    progress: 15,
    skills: ["Python", "Pandas", "ML", "Visualization"],
    accent: "#7C3AED",
    aiTag: "Suggested next roadmap",
    steps: [
      { id: "s1", name: "Python for Data", status: "in-progress" },
      { id: "s2", name: "Pandas & NumPy", status: "locked" },
      { id: "s3", name: "Statistics Core", status: "locked" },
      { id: "s4", name: "ML Fundamentals", status: "locked" },
      { id: "s5", name: "Model Deployment", status: "locked" },
    ],
    modules: [
      {
        id: "m1",
        name: "Python Data Types",
        status: "in-progress",
        desc: "Lists, dicts, comprehensions, generators.",
      },
      {
        id: "m2",
        name: "NumPy Essentials",
        status: "locked",
        desc: "Array ops, broadcasting, linear algebra.",
      },
      {
        id: "m3",
        name: "Pandas Wrangling",
        status: "locked",
        desc: "DataFrames, groupby, merge, reshape.",
      },
      {
        id: "m4",
        name: "Scikit-Learn",
        status: "locked",
        desc: "Supervised & unsupervised ML pipelines.",
      },
    ],
    insights: [
      { type: "speed", text: "Early stage — keep your 5-day streak going" },
      { type: "warn", text: "Focus on NumPy before moving to Pandas" },
      { type: "next", text: "Recommended: Complete Python module first" },
    ],
  },
  {
    id: 4,
    title: "UI/UX Design System",
    level: "intermediate",
    duration: "2 months",
    progress: 78,
    skills: ["Figma", "Design Tokens", "Accessibility", "Prototyping"],
    accent: "#F59E0B",
    aiTag: null,
    steps: [
      { id: "s1", name: "Design Principles", status: "completed" },
      { id: "s2", name: "Figma Mastery", status: "completed" },
      { id: "s3", name: "Component Systems", status: "completed" },
      { id: "s4", name: "Prototyping", status: "in-progress" },
      { id: "s5", name: "Handoff & Dev", status: "locked" },
    ],
    modules: [
      {
        id: "m1",
        name: "Visual Hierarchy",
        status: "completed",
        desc: "Typography scale, color theory, spacing.",
      },
      {
        id: "m2",
        name: "Component Library",
        status: "completed",
        desc: "Variants, auto-layout, design tokens.",
      },
      {
        id: "m3",
        name: "Interaction Design",
        status: "in-progress",
        desc: "Micro-interactions, motion, prototyping.",
      },
      {
        id: "m4",
        name: "Dev Handoff",
        status: "locked",
        desc: "Inspect mode, specs, and annotation.",
      },
    ],
    insights: [
      { type: "speed", text: "78% done — you are in the top 12% of learners" },
      { type: "warn", text: "Final module is unlocking in 2 days" },
      { type: "next", text: "Next suggested: Frontend Developer Path" },
    ],
  },
];

/* ═══════════════════════════════════════════════════════════
   KPI CARD
═══════════════════════════════════════════════════════════ */
function KPICard({ icon: Icon, iconClass, label, value }) {
  return (
    <div className="rm-kpi">
      <div className={`rm-kpi__icon rm-kpi__icon--${iconClass}`}>
        <Icon />
      </div>
      <div>
        <div className="rm-kpi__label">{label}</div>
        <div className="rm-kpi__value">{value}</div>
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════
   VIEW SWITCHER
═══════════════════════════════════════════════════════════ */
function ViewSwitcher({ view, setView }) {
  const views = [
    { id: "card", label: "Card View", Icon: Icons.GridView },
    { id: "timeline", label: "Timeline View", Icon: Icons.TimelineView },
    { id: "focus", label: "Focus View", Icon: Icons.FocusView },
  ];
  return (
    <div className="rm-switcher">
      {views.map(({ id, label, Icon }) => (
        <button
          key={id}
          className={`rm-switcher__btn${view === id ? " rm-switcher__btn--active" : ""}`}
          onClick={() => setView(id)}
        >
          <Icon />
          {label}
        </button>
      ))}
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════
   ANIMATED PROGRESS BAR
═══════════════════════════════════════════════════════════ */
function ProgressBar({ pct, accent }) {
  const [width, setWidth] = useState(0);
  useEffect(() => {
    const t = setTimeout(() => setWidth(pct), 140);
    return () => clearTimeout(t);
  }, [pct]);
  return (
    <div className="rm-progress">
      <div className="rm-progress__header">
        <span>Progress</span>
        <span style={{ color: accent, fontWeight: 600 }}>{pct}%</span>
      </div>
      <div className="rm-progress__bar">
        <div
          className="rm-progress__fill"
          style={{ width: `${width}%`, background: accent }}
        />
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════
   ROADMAP CARD
═══════════════════════════════════════════════════════════ */
function RoadmapCard({ rm }) {
  const levelLabel = rm.level.charAt(0).toUpperCase() + rm.level.slice(1);
  return (
    <div className="rm-card" style={{ "--accent": rm.accent }}>
      <div className="rm-card__top">
        <div className="rm-card__badges">
          <span className={`badge badge--${rm.level}`}>{levelLabel}</span>
          {rm.aiTag && <span className="badge badge--ai">{rm.aiTag}</span>}
        </div>
        <button className="rm-card__menu" aria-label="Options">
          <Icons.MoreDots />
        </button>
      </div>

      <div>
        <div className="rm-card__title">{rm.title}</div>
        <div className="rm-card__meta">
          <span className="rm-card__meta-item">
            <Icons.Clock /> {rm.duration}
          </span>
          <span className="rm-card__meta-item">
            <Icons.Steps /> {rm.steps.length} steps
          </span>
        </div>
      </div>

      <ProgressBar pct={rm.progress} accent={rm.accent} />

      <div className="rm-chips">
        {rm.skills.map((s) => (
          <span key={s} className="rm-chip">
            {s}
          </span>
        ))}
      </div>

      <div className="rm-card__actions">
        <button className="btn btn--primary">
          <Icons.Play />
          {rm.progress > 0 ? "Continue" : "Start"}
        </button>
        <button className="btn btn--ghost">Details</button>
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════
   TIMELINE STEP
═══════════════════════════════════════════════════════════ */
function TimelineStep({ step }) {
  const statusMap = {
    completed: { label: "Done", cls: "completed", Icon: Icons.CheckCircle },
    "in-progress": {
      label: "In Progress",
      cls: "in-progress",
      Icon: Icons.PlayCircle,
    },
    locked: { label: "Locked", cls: "locked", Icon: Icons.Lock },
  };
  const { label, cls, Icon } = statusMap[step.status];
  const btnMap = {
    completed: { cls: "rm-step__btn--start", text: "Review" },
    "in-progress": { cls: "rm-step__btn--continue", text: "Continue" },
    locked: { cls: "rm-step__btn--locked", text: "Locked" },
  };
  const btn = btnMap[step.status];

  return (
    <div className={`rm-step rm-step--${cls}`}>
      <div className={`rm-step__dot rm-step__dot--${cls}`}>
        <Icon />
      </div>
      <div className="rm-step__label">{step.name}</div>
      <div className="rm-step__status">{label}</div>
      <button
        className={`rm-step__btn ${btn.cls}`}
        disabled={step.status === "locked"}
      >
        {btn.text}
      </button>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════
   TIMELINE VIEW
═══════════════════════════════════════════════════════════ */
function TimelineView({ roadmaps }) {
  return (
    <div className="rm-timeline">
      {roadmaps.map((rm) => (
        <div key={rm.id} className="rm-timeline__roadmap">
          <div className="rm-timeline__header">
            <div>
              <div className="rm-timeline__title">{rm.title}</div>
              <div className="rm-timeline__subtitle">
                {rm.duration} · {rm.steps.length} steps
              </div>
            </div>
            <div className="rm-timeline__progress-label">
              {rm.progress}% complete
            </div>
          </div>
          <div className="rm-steps">
            {rm.steps.map((step) => (
              <TimelineStep key={step.id} step={step} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════
   PROGRESS CIRCLE (SVG animated)
═══════════════════════════════════════════════════════════ */
function ProgressCircle({ pct }) {
  const r = 34;
  const circ = 2 * Math.PI * r;
  const [offset, setOffset] = useState(circ);

  useEffect(() => {
    const t = setTimeout(() => setOffset(circ - (pct / 100) * circ), 160);
    return () => clearTimeout(t);
  }, [pct, circ]);

  return (
    <div className="rm-circle">
      <svg width="78" height="78" viewBox="0 0 78 78">
        <circle className="rm-circle__bg" cx="39" cy="39" r={r} />
        <circle
          className="rm-circle__fg"
          cx="39"
          cy="39"
          r={r}
          strokeDasharray={circ}
          strokeDashoffset={offset}
          style={{
            transition: "stroke-dashoffset 1.2s cubic-bezier(0.4,0,0.2,1)",
          }}
        />
      </svg>
      <div className="rm-circle__label">{pct}%</div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════
   MODULE (expandable accordion)
═══════════════════════════════════════════════════════════ */
function Module({ mod }) {
  const [open, setOpen] = useState(false);
  const iconMap = {
    completed: { cls: "rm-module__icon--completed", Icon: Icons.CheckCircle },
    "in-progress": {
      cls: "rm-module__icon--in-progress",
      Icon: Icons.PlayCircle,
    },
    locked: { cls: "rm-module__icon--locked", Icon: Icons.Lock },
  };
  const { cls, Icon } = iconMap[mod.status];
  const statusLabel = {
    completed: "Done",
    "in-progress": "In Progress",
    locked: "Locked",
  }[mod.status];

  return (
    <div className={`rm-module${open ? " rm-module--expanded" : ""}`}>
      <div className="rm-module__header" onClick={() => setOpen((o) => !o)}>
        <div className={`rm-module__icon ${cls}`}>
          <Icon />
        </div>
        <span className="rm-module__name">{mod.name}</span>
        <span className="rm-module__status">{statusLabel}</span>
        <span className="rm-module__chevron">
          <Icons.ChevronRight />
        </span>
      </div>
      {open && (
        <div className="rm-module__body">
          <p>{mod.desc}</p>
          {mod.status !== "locked" && (
            <button
              className="btn btn--primary"
              style={{ fontSize: 11, padding: "6px 13px" }}
            >
              <Icons.Play />
              {mod.status === "completed" ? "Review" : "Continue"}
            </button>
          )}
        </div>
      )}
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════
   FOCUS PANEL (right side of Focus View)
═══════════════════════════════════════════════════════════ */
function FocusPanel({ rm }) {
  if (!rm) {
    return (
      <div
        className="rm-focus__panel"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#94A3B8",
          fontSize: 13,
        }}
      >
        Select a roadmap to preview
      </div>
    );
  }

  const dotCls = {
    speed: "rm-ai-insight__dot--speed",
    warn: "rm-ai-insight__dot--warn",
    next: "rm-ai-insight__dot--next",
  };

  return (
    <div
      className="rm-focus__panel"
      key={rm.id}
      style={{ animation: "rm-fadein 0.25s ease both" }}
    >
      {/* ── Top: circle + info + actions */}
      <div className="rm-focus__panel-top">
        <ProgressCircle pct={rm.progress} />
        <div className="rm-focus__panel-info">
          <div className="rm-focus__panel-title">{rm.title}</div>
          <div className="rm-focus__panel-sub">
            {rm.level.charAt(0).toUpperCase() + rm.level.slice(1)} ·{" "}
            {rm.duration} · {rm.steps.length} steps
          </div>
          <div style={{ marginTop: 12, display: "flex", gap: 8 }}>
            <button className="btn btn--primary">
              <Icons.Play /> Continue
            </button>
            <button className="btn btn--ghost">
              <Icons.Book /> Overview
            </button>
          </div>
        </div>
      </div>

      {/* ── Modules accordion */}
      <div className="rm-focus__modules">
        <div className="rm-focus__modules-title">Modules</div>
        {rm.modules.map((m) => (
          <Module key={m.id} mod={m} />
        ))}
      </div>

      {/* ── AI Insights */}
      <div className="rm-focus__ai">
        <div className="rm-focus__ai-header">
          <Icons.Brain />
          AI Insights
        </div>
        <div className="rm-ai-insights">
          {rm.insights.map((ins, i) => (
            <div key={i} className="rm-ai-insight">
              <div className={`rm-ai-insight__dot ${dotCls[ins.type]}`} />
              {ins.text}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════
   FOCUS VIEW (split panel)
═══════════════════════════════════════════════════════════ */
function FocusView({ roadmaps }) {
  const [selected, setSelected] = useState(roadmaps[0]?.id ?? null);
  const rm = roadmaps.find((r) => r.id === selected);

  return (
    <div className="rm-focus">
      {/* Left: compact list */}
      <div className="rm-focus__list">
        <div className="rm-focus__list-header">Your Roadmaps</div>
        <div className="rm-focus__list-inner">
          {roadmaps.map((r) => (
            <div
              key={r.id}
              className={`rm-focus__item${selected === r.id ? " rm-focus__item--active" : ""}`}
              onClick={() => setSelected(r.id)}
            >
              <div className="rm-focus__item-title">{r.title}</div>
              <div className="rm-focus__item-meta">
                {r.level} · {r.duration}
              </div>
              <div className="rm-focus__item-bar">
                <div
                  className="rm-focus__item-fill"
                  style={{ width: `${r.progress}%`, background: r.accent }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Right: detail panel */}
      <FocusPanel rm={rm} />
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════
   ROOT — ROADMAPS PAGE
═══════════════════════════════════════════════════════════ */
export default function Roadmaps() {
  const [view, setView] = useState("card");
  const [search, setSearch] = useState("");

  const filtered = ROADMAPS.filter(
    (rm) =>
      rm.title.toLowerCase().includes(search.toLowerCase()) ||
      rm.skills.some((s) => s.toLowerCase().includes(search.toLowerCase())),
  );

  const active = ROADMAPS.filter(
    (r) => r.progress > 0 && r.progress < 100,
  ).length;
  const completed = ROADMAPS.filter((r) => r.progress === 100).length;
  const avgPct = Math.round(
    ROADMAPS.reduce((s, r) => s + r.progress, 0) / ROADMAPS.length,
  );

  return (
    <MyStudentLayout>
      <div className="rm-page">
        {/* ── HEADER ── */}
        <header className="rm-header">
          <h1 className="rm-header__title">
            My <em>Roadmaps</em>
          </h1>
          <p className="rm-header__subtitle">
            Plan, track and complete your learning journey
          </p>

          <div className="rm-kpi-strip">
            <KPICard
              icon={Icons.Roadmap}
              iconClass="garnet"
              label="Active Roadmaps"
              value={active}
            />
            <KPICard
              icon={Icons.Trophy}
              iconClass="green"
              label="Completed"
              value={completed}
            />
            <KPICard
              icon={Icons.Lightning}
              iconClass="blue"
              label="Average Progress"
              value={`${avgPct}%`}
            />
          </div>
        </header>

        {/* ── TOOLBAR ── */}
        <div className="rm-toolbar">
          <ViewSwitcher view={view} setView={setView} />
          <div className="rm-search">
            <Icons.Search />
            <input
              placeholder="Search roadmaps or skills…"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>

        {/* ── VIEWS ── */}
        <div className="rm-view" key={view}>
          {view === "card" && (
            <div className="rm-card-grid">
              {filtered.map((rm) => (
                <RoadmapCard key={rm.id} rm={rm} />
              ))}
            </div>
          )}
          {view === "timeline" && <TimelineView roadmaps={filtered} />}
          {view === "focus" && <FocusView roadmaps={filtered} />}
        </div>
      </div>
    </MyStudentLayout>
  );
}
